export const studentInBusStatus = {
    notInBus: 0,
    oldBus: 1,
    newBus: 2
}

export const tripType = {
    roundTrip: 0,
    oneWay: 1,
    returnOnly: 2
}
